const delimiters = [
    {
        value: ',',
        name: 'Comma ( , )',
        i18nKey: 'userSettings.region.form.options.comma',
    },
    {
        value: ';',
        name: 'Semicolon ( ; )',
        i18nKey: 'userSettings.region.form.options.semicolon',
    },
    {
        value: '  ',
        name: 'Tab',
        i18nKey: 'userSettings.region.form.options.tab',
    },
    {
        value: '|',
        name: 'Pipe ( | )',
        i18nKey: 'userSettings.region.form.options.pipe',
    },
];

export default delimiters;
